import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { NovaOrb } from "./NovaOrb";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-kaizen-bg flex items-center justify-center">
        <NovaOrb size={90} />
      </div>
    );
  }

  if (user === false) return <Navigate to="/login" replace />;

  return children;
};
